import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { merge } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonService } from 'src/app/common.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent {
  forgotPasswordForm: UntypedFormGroup;
  submitable = false;
  error = '';
  returnUrl: string;
  errorMessage: any;
  load: boolean = false;
  processing: boolean = false;
  constructor(private router: Router, private formBuilder: UntypedFormBuilder, private dataservice: CommonService, private _snackBar: MatSnackBar) {

    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
    this.errorMessage = { email: '', password: '' };
    merge(this.frmCtrl.email.statusChanges)
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.updateErrorMessage());
    this.load = true;
  }
  get frmCtrl() {
    return this.forgotPasswordForm.controls;
  }
  onSubmit() {
    // stop here if form is invalid
    if (this.forgotPasswordForm.invalid) {
      return;
    } else {
      this.processing = true;
      const data = {
        email: this.frmCtrl.email.value
      };
      this.dataservice.sendPostRequest('/api/reset-password-request', data).pipe(
        map((res: Response) => (JSON.stringify(res))))
        .subscribe(
          (response) => {
            this.processing = false;
            const result = JSON.parse(response);
            console.log(result);
            this.router.navigate(['verify-otp/' + result.code+'/0']);
          },
          (error) => {
            this.processing = false;
            this.error = error.error.error_message ?? error.error.error ?? 'Something went wrong. Please try again.';
            console.log(error);
          });
    }
  }

  updateErrorMessage() {
    this.submitable = true;

    if (this.frmCtrl.email.hasError('required')) {
      this.errorMessage.email = 'Email is required';
      this.submitable = false;
    } else if (this.frmCtrl.email.hasError('email')) {
      this.errorMessage.email = 'Not a valid email';
      this.submitable = false;
    }
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action);
  }
}
